<template>
  <side-bar-page :dataProps="{showUp: true,percentShow: 0}">
    <template slot="content">
      <button @click="test">Test</button>

      <div id="elementEditPost" class="container-fluid">
        <b-collapse id="filters" class="mt-2" v-model="showFilters">
          <!-- <div class="row">
            <div class="col-md-12">
              <span class="filter-label">{{$t('selectTypeOfPosts')}}</span>
            </div>
          </div> -->
          <div class="row">
            <div class="col-md-4">
              <div class="form-group has-label">
                <input type="checkbox" name="checkBoxArtist" id="checkBoxArtist" v-model="filters.forArtist" :disabled="filters.myPosts"/>
                <label class="form-radio" for="checkBoxArtist"><span>{{$t('p_filter2')}}</span></label>
              </div>
            </div>

            <div class="col-md-4">
              <div class="form-group has-label">
                <input type="checkbox" name="checkBoxAgent" id="checkBoxAgent" v-model="filters.forAgent" :disabled="filters.myPosts"/>
                <label class="form-radio" for="checkBoxAgent"><span>{{$t('p_filter1')}}</span></label>
              </div>
            </div>

            <div class="col-md-4">
              <div class="form-group has-label">
                <input type="checkbox" name="isEmailAllowed" id="isEmailAllowed" v-model="filters.myPosts" @change="disableFilters()"/>
                <label class="form-radio" for="isEmailAllowed"><span>{{$t('myPosts')}}</span></label>
              </div>
            </div>

          </div>

          <div class="row">
            <div class="col-md-12">
              <span class="filter-label second">{{$t('selectFilters')}}</span>
            </div>
          </div>

          <div class="row">
            <div class="col-md-3 margin15">
              <multiselect
                    v-model="filters.typesArtistSeleted" 
                    :options="getTypes"
                    :track-by="`type_${currentLng}`"
                    :placeholder="$t('selectTypesOfArtists')"
                    :custom-label="typesLabel"
                    @remove="removeType"
                    @select="selectType"
                    :searchable="false"
                  >
                  <template slot="selection" slot-scope="{ values, search, isOpen }"><span class="multiselect__single" v-if="values.length &amp;&amp; !isOpen">{{ values.length }} {{$t('typesSelected')}}</span></template>                    
              </multiselect>
            </div>
            <div class="col-md-3 margin15">
              <multiselect
                    v-model="filters.categoriesArtistSeleted" 
                    :options="getCategories"
                    :track-by="`name_${currentLng}`"
                    :placeholder="$t('selectCategoriesOfArtists')"
                    :custom-label="categoriesLabel"
                    @remove="removeCategories"
                    @select="selectCategories"
                    :searchable="false"
                  >
                  <template slot="selection" slot-scope="{ values, search, isOpen }"><span class="multiselect__single" v-if="values.length &amp;&amp; !isOpen">{{ values.length }} {{$t('categoriesSelected')}}</span></template>                    
              </multiselect>
            </div>
            <div class="col-md-3 margin15">
              <multiselect
                    v-model="filters.skillsArtistSeleted" 
                    :options="getSkillsList"
                    :track-by="`skill_${currentLng}`"
                    :placeholder="$t('selectSkillsOfArtists')"
                    :custom-label="skillsLabel"
                    :searchable="false"
                  >
                  <template slot="selection" slot-scope="{ values, search, isOpen }"><span class="multiselect__single" v-if="values.length &amp;&amp; !isOpen">{{ values.length }} {{$t('skillsSelected')}}</span></template>                    
              </multiselect>
            </div>
            <div class="col-md-3 margin15">
              <input :disabled="filters.forArtist || filters.myPosts" ref="autocompleteFilters" name="autocompleteFilters" class="form-control filter" 
                :placeholder="$t('enterCitySearch')" @change="clearGooglePlace"
              />
            </div>
          </div>

          <div class="row">
            <div class="col-md-12 margin15">
              <span class="filter-label third">{{$t('selectFiltersTime')}}</span>
            </div>
          </div>

          <div class="row">
            <div class="col-md-3">
              <div class="form-group has-label">
                  <datepicker class="datepicker-post" :format="dateFormatter" :language="calendarLng()" v-model="filters.date_from" :placeholder="$t('pr_placeholder_date_from')" name="dateFilterFrom"></datepicker>
              </div>
            </div>

            <div class="col-md-3">
              <div class="form-group has-label">
                  <datepicker class="datepicker-post" :format="dateFormatter" :language="calendarLng()" v-model="filters.date_to" :placeholder="$t('pr_placeholder_date_to')" name="dateFilterTo"></datepicker>
              </div>
            </div>

            <div class="col-md-3">
              <div style="margin-bottom: 10px;">
                <button class="btn btn-outline-danger btn-filter" @click="loadPosts">
                  {{$t('apply')}}
                </button>
              </div>
            </div>

            <div class="col-md-3">
              <div style="margin-bottom: 10px;">
                <button class="btn btn-outline-danger btn-filter btn-filter-alt btn-filter-m" @click="resetFilters">
                  {{$t('p_reset_filters')}}
                </button>
              </div>
            </div>
          </div>

        </b-collapse>
        <br class="hidden-xs">
        <b-row :class="$style.colReverse">
          <div class="col-md-12">
              <button 
                @click="setShowCollapse" 
                class="btn btn-fill btn-danger btn-round btn-sm btn-wd btn-post">
                {{showCollapse ? $t('cancel') : $t('addPost')}}
              </button>
              <button 
                @click="setShowFilters" 
                class="btn btn-fill btn-danger btn-round btn-sm btn-wd btn-post">
                {{$t('filters')}}
              </button>
              <span class="post-message">
                {{$t('pr_post_limit4')}} {{getUserProfile.postsLimit}} {{$t('pr_post_limit5')}}
              </span>
          </div>
        </b-row>

        <b-collapse id="collapse1" class="mt-2" v-model="showCollapse">
          <b-card>
            <b-row>
              <b-col>
                <circle-button :iAmArtist="true" :selectButton="isLookingJob" @click="isLookingJob=true"/>
              </b-col>
              <b-col>
                <circle-button :iAmArtist="false" :selectButton="!isLookingJob" @click="isLookingJob=false"/>
              </b-col>
            </b-row>
            <select-skills @change-sected-skills="selectedSkills=$event" :data="{selectedSkills: selectedSkills}"/>

            <div class="row">
              <div class="col-lg-9 col-xl-10">
                <textarea v-model="text" :placeholder="$t('enterText')" class="form-control" rows="5" style="margin-bottom: 10px;" maxlength="1000"></textarea>
              </div>
              <div class="col-lg-3 col-xl-2">             
                <div v-if="selectedPhoto" class="text-center image-select">
                  <button type="button" aria-label="Close" class="close" :title="$t('deleteImage')" @click="deleteImage()">×</button>
                  <img v-if="selectedPhoto" class="attached-img" :src="selectedPhoto"/>
                </div>
                <div class="image-select" v-if="!selectedPhoto">
                  <div @click="selectImage()" class="image-select-view trigger">
                   <span class="image-text">{{$t('pr_drag_drop_file')}}</span>
                  </div>
                  <input type="file" style="display: none;" ref="fileInput" accept="image/jpeg,image/png,image/gif,image/bmp" @change="onUploadChange($event)"/>
                </div>
              </div>
            </div>

            <div class="row" style="margin-bottom: 10px;">
              <div class="col-md-4 col-xs-12">
                <div class="form-group has-label">
                    <label>
                        {{$t('from')}}
                    </label>
                    <datepicker class="datepicker-post" :clear-button="true" :format="dateFormatter" :language="calendarLng()" v-model="date_start" :placeholder="$t('pr_placeholder_date')" name="dateBirthday"></datepicker>
                </div>
              </div>
              <div class="col-md-4 col-xs-12">
                <div class="form-group has-label">
                    <label>
                        {{$t('to')}}
                    </label>
                    <datepicker class="datepicker-post" :clear-button="true" :format="dateFormatter" :language="calendarLng()" v-model="date_end" :placeholder="$t('pr_placeholder_date')" name="dateBirthday"></datepicker>
                </div>
              </div>
              <div class="col-md-4 col-xs-12">
                <div class="form-group has-label">
                    <label>
                        {{$t('enterCityInput')}}
                    </label>
                    <input ref="autocomplete" name="autocomplete" class="form-control" :placeholder="$t('enterCityInput')" @change="clearGooglePlace"/>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-md-4">
                <button v-if="!isSendingPost" class="btn btn-outline-danger btn-filter btn-filter-m" 
                @click="sendPost" :disabled="!text.length">{{$t('save')}}</button>
              </div>
            </div>

            <sync-loader v-if="isSendingPost" class="text-center" color="red"></sync-loader>
          </b-card>
        </b-collapse>
        <div v-if="isLoadingPosts">
          {{$t('loading')}}...
          <spinner-loader color="red"></spinner-loader>
        </div>
        <div v-if="!isLoadingPosts && !posts.length && !showCollapse" class="no-find-result">{{$t('noFind')}}...</div>
        <div v-if="!isLoadingPosts && !posts.length && !showCollapse">
        </div>
        <div v-if="!isLoadingPosts && posts.length" class="post-container">
          <gallery :input="posts" :index="indexImg" @close="indexImg = null"></gallery>
          <b-row class="card card-post" v-for="(post, postIndex) in posts" :key="postIndex" :id="'post'+postIndex">
            <div class="col-md-12">
              <div class="control-btn" v-if="post.usersId===getUserProfile.id">
                <b-button size="sm" variant="outline-danger" :title="$t('edit')" @click="editPost(post)"><i class="fa fa-edit"></i></b-button>
                <b-button size="sm" variant="outline-danger" :title="$t('delete')" @click="deletePost(post)"><i class="fa fa-trash"></i></b-button>
              </div>
            </div>
            <router-link :to="{name: 'profile', params: {id: post.users.id}}">
              <div style="width: 100%;">
                <img :src="post.users.avatar" class="image-avatar"/>{{post.users.firstName}} {{post.users.lastName}}
              </div>
            </router-link>
            <div class="col-md-12 disable-col-padding status-post">
              <div v-if="post.participantType === 1"><i class="fa fa-check fa-post"></i>{{$t('availableForContract')}}</div>
              <div v-if="post.participantType !== 1"><i class="fa fa-search fa-post"></i> {{$t('lookingFor')}}</div>
            </div>
            <div class="col-md-12 disable-col-padding">
              <div v-if="post.artistTypesList.length" class="skills-post">
                <p v-for="(skill, index) in post.artistTypesList" :key="index">{{getSkillString(skill)}}</p>
              </div>
              <div class="row">
                <div class="col-md-10" v-if="post.href">
                  <div v-for="(text,index) in post.localeTextsList" :key="index" class="message-post">
                    {{text.text}}
                  </div>
                </div>

                <div class="col-md-12" v-if="!post.href">
                  <div v-for="(text,index) in post.localeTextsList" :key="index" class="message-post">
                    {{text.text}}
                  </div>
                </div>
                <div class="col-md-2 disable-col-padding-l enable-col-padding-m" v-if="post.href">
                  <div class="image post-image" v-if="post.href" 
                    @click="indexImg = postIndex" 
                    :style="{ backgroundImage: 'url(' + post.href + ')'}">
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-md-6 col-8" v-if="post.date_start">
                  <div class="date-post">
                    <i class="fa fa-calendar-o fa-post"></i> {{onlyDate(post.date_start)}}{{post.date_end ? ` - ${onlyDate(post.date_end)}` : ''}}
                  </div>
                </div>

                <div class="col-md-6 col-8" v-if="!post.date_start"></div>
                <div class="col-md-6 col-4">
                  <div class="location-post date text-right">
                    {{$t('created')}} {{dateFormatter(post.created)}}
                  </div>
                </div>

                <div class="col-md-12" v-if="post.googlePlace">
                  <div class="location-post">
                    <i class="fa fa-map-marker fa-post"></i> {{post.googlePlaceLocales && post.googlePlaceLocales[currentLng] && post.googlePlaceLocales[currentLng].formatted_address}}
                  </div>
                </div>
              </div>

            </div>
          </b-row>
          <b-pagination v-if="maxPage>1" v-model="currentPage" :total-rows="allPostsCount" :per-page="countPerPage" size="md" align="center" @input="setPage"/>
        </div>
      </div>
    </template>
  </side-bar-page>
</template>

<script>
  import Multiselect from 'vue-multiselect'
  import 'vue-multiselect/dist/vue-multiselect.min.css'
  import { mapActions, mapGetters } from 'vuex'
  import CircleButton from '../components/CircleButton'
  import SideBarPage from '../components/SideBarPage'
  import SpinnerLoader from 'vue-spinner/src/PulseLoader.vue'
  import {POST_DELETE, POST_SEND, POSTS_LOAD, USER_AVATAR_LOAD} from "../store/actions/userConst"
  import {GOOGLE_GET_PLACE} from "../store/actions/langConst"
  import { interval } from 'rxjs'
  import { takeUntil, filter } from 'rxjs/operators'
  import SelectSkills from "../components/SelectSkills"
  import swal from 'sweetalert2'
  import datepicker from 'vuejs-datepicker';
  import gallery from 'gallery-vue';
  import syncLoader from 'vue-spinner/src/PulseLoader.vue';
  import imageOptimizer from "../modules/imageOptimizer";
  import {en, ru} from 'vuejs-datepicker/dist/locale';

  var moment = require('moment');
  moment().format();

  export default {
    name: 'posts',
    components: { SideBarPage, SpinnerLoader, CircleButton, SelectSkills, Multiselect, datepicker, gallery, syncLoader },
    beforeRouteUpdate (to, from, next) {
      this.currentPage = to.params.page
      if(this.getUserProfile.id && this.getArtistTypes.length && this.getSkills.length) {
        this.loadPosts()
      } else {
        const obs = interval(1000)
        obs
          .pipe(takeUntil(obs.pipe(filter(val => {
            if(this.getUserProfile.id && this.getArtistTypes.length && this.getSkills.length) {
              this.loadPosts()
              return true
            } else {
              if(val>30) {
                console.log('time out 30s. for load profile')
                return true
              }
            }
          }))))
          .subscribe(()=>{});
      }
      next()
    },
    beforeDestroy() {
      this.RxLngPointer.unsubscribe()
      this.RxGooglePointer.unsubscribe()
    },
    mounted() {
      if(!this.$route.params.page) {
        this.$router.push({name: 'posts', params: {page: 1}})
      } else {
        let page = parseInt(this.$route.params.page)
        if(page) {
          if(page.toString()===this.$route.params.page) {
            this.currentPage = page
          } else {
            this.$router.push({name: 'posts', params: {page: page}})
          }
        } else {
          this.$router.push({name: 'posts', params: {page: 1}})
        }
      }
      this.RxLngPointer = this.RxLng.subscribe(()=> {
        this.updateGooglePlace();
      });
      this.RxGooglePointer = this.RxGoogle.subscribe(gPlace=>{
        if(gPlace) {
          let autocomplete = new gPlace.Autocomplete(this.$refs.autocomplete, {types: ['(cities)']})
          autocomplete.addListener('place_changed', ()=>{
            this.googlePlace = autocomplete.getPlace()
          })
          let autocompleteFilters = new gPlace.Autocomplete(this.$refs.autocompleteFilters, {types: ['(cities)']})
          autocompleteFilters.addListener('place_changed', ()=>{
            this.filters.googlePlace = autocompleteFilters.getPlace()
          })
        }
      });
      this.$root.$on('bv::collapse::state', (collapseId) => {
        if (collapseId === 'collapse1') {
          this.$nextTick(function () {
            // DOM updated
            window.dispatchEvent(new Event('resize'));
          });
        }
      });
    },
    created() {
      const obs = interval(1000)
      obs
        .pipe(takeUntil(obs.pipe(filter(val => {
          if(this.getUserProfile.id && this.getArtistTypes.length && this.getSkills.length) {
            this.initFilters();
            this.loadPosts()
            return true
          } else {
            if(val>30) {
              console.log('time out 30s. for load profile')
              return true
            }
          }
        }))))
        .subscribe(()=>{});
    },
    data() {
      return {
        post: {},
        posts: [],
        isLookingJob: true,
        // skills: [],
        // artistTypes: [],
        selectedSkills: [],
        showCollapse: false,
        date_start: null,
        date_end: null,
        text: '',
        postId: null,
        googlePlace: null,
        cacheAvatars: [],
        showFilters: false,
        myPostsCount: 0,
        RxLngPointer: null,
        RxGooglePointer: null,
        currentPage: 1,
        allPostsCount: 0,
        maxPage: 1,
        filters: {
          typesArtistSeleted: [], categoriesArtistSeleted: [], skillsArtistSeleted: [],
          googlePlace: null,
          forArtist: true,
          forAgent:true,
          date_from: null,
          date_to: null,
          myPosts: false,
        },
        indexImg: null,
        postUploadImage: null,
        postImageObject: null,
        imageCompressLevel: 0.7, // 70% quality
        toast: swal.mixin({
                toast: true,
                position: 'bottom-start',
                customClass: 'sweet-modal',
                showConfirmButton: false,
                timer: 5000
        }),
        selectedPhoto: null,
      }
    },
    computed: {
      ...mapGetters(['currentLng', 'getUserProfile', 'isLoadingPosts', 'isSendingPost', 'getAccessToken', 'RxGoogle', 'RxLng', 'countPerPage','getSkills','getArtistTypes']),
      postSend() {
        let place;
        if (this.googlePlace && (typeof this.googlePlace.place_id !== 'undefined')) {
          place = this.googlePlace.place_id;
        } else {
          place = '';
        }
        let post = {
          id: this.post.id,
          usersId: this.getUserProfile.id,
          participantType: !this.isLookingJob + 1,
          googlePlace: place,
          localeTextsList: this.post.id ? [{id: this.post.localeTextsList[0].id, locale: this.post.localeTextsList[0].locale, text: this.text}] :
            [{locale: this.currentLng, text: this.text}],
          artistTypesList: this.selectedSkills,
          date_start: this.date_start,
          date_end: this.date_end,
          created: this.post.created,
          imageId: '',
        }
        for(let key in post) {
          if(!post[key]) delete post[key]
        }
        return post
      },
      getTypes() {
        let data = JSON.parse(JSON.stringify(this.getArtistTypes))
        return data.sort((a,b)=>a[`type_${this.currentLng}`].localeCompare(b[`type_${this.currentLng}`]))
      },
      getCategories() {
        let res = [];
        if(Array.isArray(this.filters.typesArtistSeleted)) {
          this.filters.typesArtistSeleted.forEach(t=>{
            t.categories.forEach(c=>res.push(JSON.parse(JSON.stringify(c))))
          })
        } else {
          if(this.filters.typesArtistSeleted) {
            this.filters.typesArtistSeleted.categories.forEach(c=>res.push(JSON.parse(JSON.stringify(c))))
          }
        }
        return res.sort((a,b)=>a[`name_${this.currentLng}`].localeCompare(b[`name_${this.currentLng}`]))
      },
      getSkillsList() {
        let skillsList = [];
        if(Array.isArray(this.filters.categoriesArtistSeleted)) {
          this.filters.categoriesArtistSeleted.forEach(c=>{
            c.skills.forEach(s=>{
              if(skillsList.indexOf(s)===-1) skillsList.push(s)
            })
          })
        } else {
          if(this.filters.categoriesArtistSeleted) {
            this.filters.categoriesArtistSeleted.skills.forEach(s=>{
              if(skillsList.indexOf(s)===-1) skillsList.push(s)
            })
          }
        }
        return this.getSkills.filter(s=>skillsList.indexOf(s.code)!=-1).sort((a,b)=>a[`skill_${this.currentLng}`].localeCompare(b[`skill_${this.currentLng}`]))
      },
    },
    methods: {
      ...mapActions([POST_SEND, POSTS_LOAD, POST_DELETE, USER_AVATAR_LOAD, GOOGLE_GET_PLACE]),
      test() {
        console.log(this.posts);
      },
      setPage() {
        this.$router.push({name: 'posts', params: { page: this.currentPage }})
      },
      calendarLng() {
        if (this.currentLng === 'ru') {
          return ru;
        } else if (this.currentLng === 'en') {
          return en;
        }
      },
      dateFormatter(date) {
        return moment(date).format('DD.MM.YYYY');
      },
      clearGooglePlace(evn) {
        if(evn.target.attributes.name.nodeValue === 'autocompleteFilters') {
          if(!evn.target.value.length) this.filters.googlePlace = null
        } else {
          if(!evn.target.value.length) this.googlePlace = null
        }
      },
      selectType() {
        this.filters.categoriesArtistSeleted = null
        this.filters.skillsArtistSeleted = null
      },
      selectCategories() {
        this.filters.skillsArtistSeleted = null
      },
      removeCategories(removedOption) {
        if(Array.isArray(removedOption)) {
          removedOption.skills.forEach(s=>{
            let indexSkill = this.filters.skillsArtistSeleted.findIndex(sl=>sl.code===s)
            if(indexSkill>-1) this.filters.skillsArtistSeleted.splice(indexSkill,1)
          })
        } else {
          this.filters.skillsArtistSeleted = null
        }
      },
      removeType(removedOption) {
        if(Array.isArray(removedOption)) {
          removedOption.categories.forEach(t=>{
            let indexCat = this.filters.categoriesArtistSeleted.findIndex(c=>c.name_en===t.name_en)
            if(indexCat>-1) {
              this.filters.categoriesArtistSeleted[indexCat].skills.forEach(s=>{
                let indexSkill = this.filters.skillsArtistSeleted.findIndex(sl=>sl.code===s)
                if(indexSkill>-1) this.filters.skillsArtistSeleted.splice(indexSkill,1)
              })
              this.filters.categoriesArtistSeleted.splice(indexCat,1)
            }
          })
        } else {
          this.filters.categoriesArtistSeleted = null
          this.filters.skillsArtistSeleted = null
        }
      },
      typesLabel(option) {
        return option[`type_${this.currentLng}`]
      },
      categoriesLabel(option) {
        return option[`name_${this.currentLng}`]
      },
      skillsLabel(option) {
        return option[`skill_${this.currentLng}`]
      },
      loadPosts() {
        let whereParams = {
          and: []
        };
        let dateParams = {};
        // date params as ISO string
        if (this.filters.date_from && this.filters.date_to) {
          // substract 1 day to left limit point
          dateParams.from = moment(this.filters.date_from).subtract(1, 'days').toDate().toISOString();
          // add 1 day to right limit point
          dateParams.to = moment(this.filters.date_to).add(1, 'days').toDate().toISOString();
          whereParams.and.push( { date_start: { gte: new Date(dateParams.from) } } );
          whereParams.and.push( { date_end: { lte: new Date(dateParams.to) } } );
        } else if (this.filters.date_from) {
          dateParams.from = moment(this.filters.date_from).subtract(1, 'days').toDate().toISOString();
          whereParams.and.push( { date_start: { gte: new Date(dateParams.from) } } );
        } else if (this.filters.date_to) {
          dateParams.to = moment(this.filters.date_to).add(1, 'days').toDate().toISOString();
          whereParams.and.push( { date_end: { lte: new Date(dateParams.to) } } );
        }
        // show only my posts
        if (this.filters.myPosts) {
          // whereParams.and = [];
          whereParams.and.push({usersId: {eq: this.getUserProfile.id}});
        } else {
          if (!this.filters.forArtist) {
            whereParams.and.push({participantType: {neq: 2}});
          }
          if (!this.filters.forAgent) {
            whereParams.and.push({participantType: {neq: 1}});
          } else {
            this.filters.googlePlace ? whereParams.and.push({'googlePlace': {eq: this.filters.googlePlace.place_id}}) : false;
          }
        }
        if(Array.isArray(this.filters.typesArtistSeleted)) {
          // Работает только частично, нужно переделывать если потребуется
          this.filters.typesArtistSeleted.forEach(item=>whereParams.and.push({'artistTypesList.artistTypeId': {eq: item.id}}))
          this.filters.categoriesArtistSeleted.forEach(item=>whereParams.and.push({'artistTypesList.categories': {eq: item.name_en}}))
          this.filters.skillsArtistSeleted.forEach(item=>whereParams.and.push({'artistTypesList.skill': {eq: item.code}}))
        } else {
          if(this.filters.typesArtistSeleted) whereParams.and.push({'artistTypesList.artistTypeId': {eq: this.filters.typesArtistSeleted.id}})
          if(this.filters.categoriesArtistSeleted) whereParams.and.push({'artistTypesList.categories': {eq: this.filters.categoriesArtistSeleted.name_en}})
          if(this.filters.skillsArtistSeleted) whereParams.and.push({'artistTypesList.skill': {eq: this.filters.skillsArtistSeleted.code}})
        }
        let twoYears = moment(new Date()).subtract(2, 'years').toDate().toISOString();
        whereParams.and.push({ 'created': {gte: twoYears } });
        if(!whereParams.and.length) delete whereParams.and;
        // console.log(whereParams);
        // console.log(dateParams);
        this.POSTS_LOAD({id: this.getUserProfile.id,where: whereParams,skip: (this.currentPage-1)*this.countPerPage,limit: this.countPerPage, dateParams: dateParams})
          .then(res=>{
            this.myPostsCount=res.myPostsCount
            this.posts=res.posts
            this.allPostsCount = res.allPostsCount
            this.maxPage = parseInt(this.allPostsCount/this.countPerPage) + ((this.allPostsCount % this.countPerPage)?1:0)
            if(this.maxPage) {
              if(this.currentPage>this.maxPage) {
                this.$router.push({name: 'posts', params: { page: this.maxPage }})
              } 
            }
            this.updateAvatarCache()
            this.updateGooglePlace()
          })
          .catch(err=>console.log(err))
      },
      updateGooglePlace() {
        this.posts.forEach(post=>{
          if(post.googlePlace) {
            post.googlePlaceLocales = post.googlePlaceLocales || {}
            if(!post.googlePlaceLocales[this.currentLng]) {
              this.GOOGLE_GET_PLACE({place_id: post.googlePlace, language: this.currentLng, fields: ['formatted_address']})
                .then(place=>{
                  post.googlePlaceLocales[this.currentLng]=place
                  this.posts.push({})
                  this.posts.splice(this.posts.length-1,1)
          })
          .catch(err=>console.log(err))
            }
          }
        })
      },
      updateAvatarCache() {
        this.posts.forEach(element => {
          if(element.users) {
            if(!~this.cacheAvatars.findIndex(c=>c.id===element.usersId)) {
              this.cacheAvatars.push({id: element.usersId})
            }
          } else {
            element.users = {}
            element.users.firstName = 'Unknow'
            element.users.lastName = 'User'
          }
        })
        this.cacheAvatars.forEach(c => {
          if(!c.avatar) {
            this.USER_AVATAR_LOAD(c)
              .then((img)=>{
                c.avatar = img
                this.posts.filter(p=>p.usersId===c.id).forEach(p1=>p1.users.avatar=c.avatar)
                this.posts.push({})
                this.posts.splice(this.posts.length-1,1)
              })
              .catch((err)=>console.log(err))
          } else {
            this.posts.filter(p=>p.usersId===c.id).forEach(p1=>p1.users.avatar=c.avatar)
            this.posts.push({})
            this.posts.splice(this.posts.length-1,1)
          }
        })
      },
      clearPostFields() {
        this.post = {}
        this.selectedSkills = []
        this.text = ''
        this.date_start = null
        this.date_end = null
        this.googlePlace = null
        // if(!this.isLookingJob) {
          // this.$refs.autocomplete.$refs.input.value = ''
          this.$refs.autocomplete.value = ''
        // }
        this.selectedPhoto = null;
      },
      setShowCollapse() {
        if(this.showCollapse) {
          this.clearPostFields()
        }
        this.showCollapse = !this.showCollapse
        if(this.showCollapse) this.showFilters=false
      },
      setShowFilters() {
        this.showFilters=!this.showFilters
        if(this.showFilters && this.showCollapse) this.setShowCollapse()
      },
      deletePost(post) {
        swal({
          title: this.$t('areYouSure'),
          text: this.$t('text29'),
          type: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          confirmButtonText: this.$t('yesDeleteIt'),
          cancelButtonColor: '#d33',
          cancelButtonText: this.$t('cancel')
        }).then((result) => {
          if (result.value) {
            this.POST_DELETE(post.id)
              .then(()=>{
                // this.posts.splice(index,1)
                // this.myPostsCount--
                this.loadPosts()
                swal(
                  this.$t('deleted'),
                  this.$t('text30'),
                  'success'
                )
              })
              .catch(err=>console.log(err))
          }
        })
      },
      editPost(post) {
        if(post.googlePlace) {
          this.GOOGLE_GET_PLACE({place_id: post.googlePlace, language: this.currentLng})
            .then(place=>{
              this.googlePlace = place
              this.$refs.autocomplete.value = place.formatted_address
            })
            .catch(err=>console.log(err))
        }
        this.post = post
        this.isLookingJob = post.participantType === 1
        this.text = post.localeTextsList[0].text
        this.selectedSkills = post.artistTypesList
        this.date_start = post.date_start ? (new Date(post.date_start)).toISOString().split('T')[0] : null
        this.date_end = post.date_end ? (new Date(post.date_end)).toISOString().split('T')[0] : null
        this.showCollapse = true
        this.$scrollTo('#elementEditPost', 1000, { container: '#scroll' })
        // preload image to component
        this.selectedPhoto = this.post.href;
      },
      onlyDate(date) {
        let buf = new Date(date)
        return buf.toLocaleString('ru',{day: 'numeric', month: 'numeric', year: 'numeric'})
      },
      preparePostWithImage() {
        imageOptimizer(this.postImageObject, 1920, 0.6, (blob, base64) => {
            if (!blob) {
              this.toast.fire({
                  title: '<i class="fa fa-times fa-2x"></i>' + this.$t('up_err_filetype')
              });
            }
            this.postUploadImage = base64;
            // console.log('preparePostWithImage');
            // console.log(blob);
            this.sendPostWithImage(blob);
        });
      },
      sendPostWithImage(blob) {
          let formData = new FormData();
          formData.append('file', blob, blob.name);
          console.log(formData);
          this.POST_SEND({ post: Object.assign(this.postSend, {image: true}), image: formData})
            .then(res=>{
              // success -> reset picture input
              this.selectedPhoto = null;
              if(res.id) {
                // this.post = res
                // this.post.users = {id: this.getUserProfile.id, firstName: this.getUserProfile.firstName, lastName: this.getUserProfile.lastName}
                // this.post.href = this.postUploadImage;
                // this.posts.unshift(this.post);
                // this.myPostsCount++
                // this.updateAvatarCache()
                // this.postUploadImage = null;
                // this.postImageObject = null;
                this.loadPosts()
                this.$scrollTo('#elementEditPost', 1000, { container: '#scroll' })
              } else {
                // let index = this.posts.findIndex(p=>p.id===this.post.id)
                // let buf = this.posts[index]
                // buf.artistTypesList = this.postSend.artistTypesList
                // buf.googlePlace = this.postSend.googlePlace
                // buf.localeTextsList = this.postSend.localeTextsList
                // buf.participantType = this.postSend.participantType
                // buf.googlePlaceLocales = null
                // buf.href = this.postUploadImage;
                // this.posts.splice(index, 1, buf)
                // this.postUploadImage = null;
                // this.postImageObject = null;
                // this.$scrollTo('#post'+index, 1000, { container: '#scroll' })
                this.loadPosts()
              }
              this.showCollapse = false
              this.clearPostFields()
              this.updateGooglePlace()
            }).catch((err)=> {
              console.log(err);
              // error send post -> reset picture input
              this.selectedPhoto = null;
              this.postUploadImage = null;
              this.postImageObject = null;
              const code = this.$ObjValidate(() => err.response.data.error.code) ? err.response.data.error.code : '';
              if (code === 'UPLOAD_POST_LIMIT') {
                  this.toast.fire({
                          title: '<i class="fa fa-exclamation fa-2x"></i>' + this.$t('pr_post_limit', {limit: this.getUserProfile.postsLimit})
                      });
                  this.showCollapse = false;
                  this.clearPostFields();
              } else {
                  this.toast.fire({
                      title: '<i class="fa fa-times fa-2x"></i>' + this.$t('p_post_not_uploaded')
                  });
              }
            });
      },
      sendPost() {
        // console.log(this.postImageObject);
        // console.log(this.selectedPhoto);
        // return;
        if (this.postImageObject) {
          this.preparePostWithImage();
        } else {
          let postObject;
          if (this.selectedPhoto) {
            postObject = Object.assign(this.postSend, {image: false, deleteImage: false});
          } else {
            postObject = Object.assign(this.postSend, {image: false, deleteImage: true});
          }
          this.POST_SEND({ post: postObject, image: {}})
          .then(res=>{
            if(res.id) {
              // this.post = res
              // this.post.users = {id: this.getUserProfile.id, firstName: this.getUserProfile.firstName, lastName: this.getUserProfile.lastName}
              // this.posts.unshift(this.post)
              // this.myPostsCount++
              // this.updateAvatarCache()
              this.loadPosts()
              this.$scrollTo('#elementEditPost', 1000, { container: '#scroll' })
            } else {
              this.loadPosts()
              // let index = this.posts.findIndex(p=>p.id===this.post.id)
              // let buf = this.posts[index]
              // buf.artistTypesList = this.postSend.artistTypesList
              // buf.googlePlace = this.postSend.googlePlace
              // buf.localeTextsList = this.postSend.localeTextsList
              // buf.participantType = this.postSend.participantType
              // buf.googlePlaceLocales = null
              // this.posts.splice(index, 1, buf)
              // this.$scrollTo('#element'+index, 1000, { container: '#scroll' })
            }
            this.showCollapse = false
            this.clearPostFields()
            this.updateGooglePlace()
          })
          .catch((err)=> {
            console.log(err);
            const code = this.$ObjValidate(() => err.response.data.error.code) ? err.response.data.error.code : '';
            if (code === 'UPLOAD_POST_LIMIT') {
                this.toast.fire({
                        title: '<i class="fa fa-exclamation fa-2x"></i>' + this.$t('pr_post_limit', {limit: this.getUserProfile.postsLimit})
                    });
                this.showCollapse = false;
                this.clearPostFields();
            } else {
                console.log(err);
                this.toast.fire({
                    title: '<i class="fa fa-times fa-2x"></i>' + this.$t('p_post_not_uploaded')
                });
            }
          });
        }
      },
      getSkillString(skill) {
        let aType = this.getArtistTypes.find(t=>t.id===skill.artistTypeId)
        if(aType) {
          let aCat = aType.categories.find(c=>c.name_en===skill.categories)
          if(aCat) {
            let aSkill = this.getSkills.find(s=>s.code===skill.skill)
            if(aSkill) {
              return `${aType['type_'+this.currentLng]} -> ${aCat['name_'+this.currentLng]} -> ${aSkill['skill_'+this.currentLng]}`
            } else {
              console.log(`Ненайден skill артиста с code=${skill.skill}`)
            }
          } else {
            console.log(`Ненайдена категория артиста с ID=${skill.artistTypeId} name_en=${skill.categories}`)
          }
        } else {
          console.log(`Ненайден тип артиста с ID=${skill.artistTypeId}`)
        }
        return 'Error!'
      },
      modalClosed() {
          console.log('modalClosed');
      },
      modalShowed() {
          console.log('modalShowed');
      },
      onUploadChange(evt) {
        let reader = new FileReader();
        try {
          reader.onload = (e) => {
            this.selectedPhoto = e.target.result;
            this.postImageObject = evt.target.files[0];
          }
          reader.readAsDataURL(evt.target.files[0]);
        } catch (error) {
          console.log('FileReader API not supported: use the <form>');
          this.toast.fire({
            title: '<i class="fa fa-times fa-2x"></i>' + error.message
          });
        }
      },
      selectImage() {
        this.$refs.fileInput.click();
      },
      deleteImage() {
        this.selectedPhoto = null;
        this.postImageObject = null;
      },
      disableFilters() {
        if (this.filters.myPosts) {
          this.filters.forArtist = false;
          this.filters.forAgent = false;
        }
      },
      initFilters() {
        if (this.getUserProfile.userType === 'artist') {
          this.filters.forArtist = true;
          this.filters.forAgent = false;
        }
        if (this.getUserProfile.userType === 'agent') {
          this.filters.forArtist = false;
          this.filters.forAgent = true;
        }
      },
      resetFilters() {
        this.filters.myPosts = false;
        this.initFilters();
        this.filters.date_from = null;
        this.filters.date_to = null;
        this.removeCategories();
        this.removeType();
        this.filters.typesArtistSeleted = null;
        this.loadPosts();
      },
    },
  }
</script>

// <style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style lang="scss" module>
  .buttonDisabled {
    cursor: not-allowed !important;
  }
  .checkbox-label {
    display: block
  }
  @media only screen and (max-width: 576px) {
    .colReverse { 
      -webkit-flex-direction: column-reverse;
      flex-direction: column-reverse;
    }  
  }
</style>

<style scoped>
.card label {
  font-size: 14px;
  margin-bottom: 5px;
  text-transform: uppercase;
  font-weight: 400;
  color: #828080;
}
label {
  display: inline-block;
}
.image-avatar {
    width: 50px;
    height: 50px;
    border-radius: 100px;
    border: 1px solid #eee;
    margin-right: 10px;
}
.card-post {
  padding: 20px;
  margin-bottom: 20px;
  color: #565656 !important;
}
.card-post .control-btn {
  position: absolute;
  right: 0px;
}
.card-post .btn-outline-danger {
  margin-right: 3px;
}
.card-post .status-post {
  margin-top: 10px;
  margin-bottom: 10px;
}
.card-post .status-post .fa {
  margin-right: 5px;
}
.card-post .skills-post { 
  background-color: white; 
  border: 1px solid rgba(0, 0, 0, 0.125);
  border-radius: 0.25rem;
  padding: 10px;
  margin-top: 10px;
  max-height: 100px; 
  overflow-y: auto;
}
.card-post .skills-post::-webkit-scrollbar {
    width: 8px
}
.card-post .skills-post p { 
  margin-bottom: 5px;
}
.card-post .message-post {
  background-color: white; 
  border: 1px solid rgba(0, 0, 0, 0.125);
  border-radius: 0.25rem;
  padding: 10px;
  margin-top: 10px;
  height: 100px; 
  overflow-y: auto;
}
.card-post .date-post,
.card-post .location-post {
  margin-top: 10px;
}
.card-post .fa-map-marker {
  font-size: 20px;
  padding-right: 3px;
}
.card-post .fa-post {
  color: #474747 !important;
  padding-right: 5px;
}
.btn-post {
  border-radius: 4px !important;
  margin-right: 15px;
  margin-left: 6px;
  margin-bottom: 10px;
}
.btns-upload {
    border-radius: 100px !important;
    padding-left: 20px !important;
    padding-right: 20px !important;
    padding-top: 3px !important;
    font-weight: 500 !important;
    height: 33px !important;
}
.btn-outline-danger {
    min-width: 32px;
}
.image {
    float: left;
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center center;
    border: 1px solid #ebebeb;
    margin-top: 10px;
}
.post-image {
    width: 100% !important;
    height: 100px;
    border-radius: 4px;
    cursor: pointer;
    transition: all 0.3s;
}
.row-gallery {
        border: 1px solid rgba(0, 0, 0, 0.125);
        /* border-radius: 0.25rem; */
        min-height: 212px;
        background-image: url('../assets/img/no-media.png');
        background-size: 180px;
        background-repeat: no-repeat;
        background-position-x: 15px;
        background-position-y: 15px;
}
#elementEditPost {
  padding-top: 10px;
}
input[name='autocomplete'] {
  margin-bottom: 20px;
}
.post-container {
  padding: 20px;
}
.message-post::-webkit-scrollbar {
  width: 7px !important;
}
.post-message {
  float: right;
  padding-right: 10px;
  color: #565656;
}
.no-find-result {
  text-align: center;
  color: #565656;
  padding-top: 50px;
  padding-bottom: 50px;
}
#collapse1 {
  margin-bottom: 10%;
}

.image-select-view {
  width: 95%;
  height: 135px;
  background-color: grey;
  cursor: pointer;
  text-align: center;
  display: block;
  /* display: table-cell; */
  /* vertical-align: middle; */
  padding: 8px;
  border-radius: 0.25rem;
  color: #efefef;
  text-shadow: 1px 1px 1px #000000d6;
}
.image-select {
  margin-top: 0px;
  width: 95%;
}
.attached-img {
  width: 95%;
  height: 135px;
  object-fit: cover;
  cursor: pointer;
  border-radius: 0.25rem;
}
.image-text {
  text-overflow: ellipsis;
  display: inline-block;
  overflow: hidden;
  width: 100%;
  text-align: center;
  font-size: 14px;
  /* white-space: nowrap; */
  position: relative;
  top: 20%;
}
.image-select .close {
  display: inline-block;
  position: absolute;
  right: 5px;
  top: -10px;
  color: red;
  font-weight: bold;
}
.form-group input::placeholder {
    color: rgb(206, 212, 218) !important;
}
.form-radio span {
    font-size: 14px !important;
    padding-left: 3px;
    position: relative;
    top: -3px;
    /* margin-bottom: 5px; */
}
.form-group label.form-radio {
    font-size: 22px;
    margin-bottom: 5px;
    text-transform: uppercase;
    font-weight: 400;
    color: #565656;
    line-height: 1;
    margin-top: 10px;
}
input[type="checkbox"]:disabled ~ label {
    color: #a9abad !important;
    cursor: not-allowed;
}
.filter-label {
  color: #565656;
  display: inline-block;
}
.filter-label.second {
  margin-bottom: 10px;
}
.filter-label.third {
  margin-bottom: 10px;
  margin-top: 10px;
}
.form-control.filter {
    background-color: #fff;
    border-radius: 4px;
    font-size: 14px;
    color: #565656;
    padding: 8px 12px;
    height: 40px;
    -webkit-box-shadow: none;
    box-shadow: none;
}
input.form-control.filter::placeholder {
    color: #adadad !important;
}
.form-control.filter:disabled {
  cursor: not-allowed;
  background-color: #e9ecef;
  color: #bdbdbd !important;
}
@media only screen and (max-width: 768px) {
  .btn-outline-danger {
    display: block;
    margin-top: 5px;
    min-width: 32px;
  }
  .card-post .control-btn {
    position: absolute;
    right: -10px;
    top: -12px;
  }
  .btn-wd {
    min-width: 10px !important;
    font-size: 0.68rem !important;
  }
  .btn-post {
    margin-right: 5px;
  }
  .card-post .message-post {
    margin-top: 10px;
    height: auto; 
    overflow-y: hidden;
  }
  #elementEditPost {
    padding-top: 0px;
  }
  .post-container {
    padding: 5px;
  }

  .image-select .close {
    right: 10px;
  }
  .image-select {
    width: 100%;
    margin-top: 10px;
    margin-bottom: 10px;
  }
  .image-select-view {
    width: 100%;
  }
  .image-select img {
    width: 93% !important;
    float: left;
    margin-bottom: 10px;
  }
  .image-select-view {
    padding-left: 20px;
    padding-right: 20px;
  }
  .btn-filter-m {
    margin-bottom: 40px;
  }
  .margin15 {
    margin-top: 15px;
  }
}
</style>

<style>
.image-select .picture-inner .picture-inner-text {
    font-size: 0.8rem !important;
    line-height: 1.35 !important;
}
.image-select .preview-container {
  float: left !important;
  margin-bottom: 20px !important;
}
.multiselect__placeholder {
    text-overflow: ellipsis;
    white-space: nowrap;
}
.multiselect__tags {
    height: 40px !important;
    border: 1px solid #ced4da;
}
.multiselect__single {
    font-size: 14px !important;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
}
.vdp-datepicker.datepicker-post > div > input {
  font-size: 14px !important;   
}
.vdp-datepicker.datepicker-post > div > input::placeholder {
  color: #adadad !important;
}
</style>
